import { GenericHeader, SearchBar } from 'components';
import ListComp from 'components/ListComp';
import React from 'react';
import { PayOption } from 'services';
import { curriculum_manager } from 'utils/constants';
import { Results, CreateModal } from './components';
import { Button } from '@material-ui/core';

const PayOptionList = props => {
  let { lesson_id } = props;
  const Head = props => {
    let { handleCreateOpen, ...rest } = props;
    return (
      <GenericHeader
        header={`Payment Options`}
        subheader="Payment Option Management " {...rest}>
        <Button color="primary" onClick={handleCreateOpen} variant="contained">
          Add Payment Option
        </Button>
      </GenericHeader>
    );
  }

  return (
    <ListComp
      listing={PayOption.list}
      title="Payment Options"
      name="payment_options"
      searchable
      SearchBar={SearchBar}
      Header={Head}
      Results={Results}
      roles={[curriculum_manager]}
      CreateComp={CreateModal}
      filters={{ limit: 10, offset: 0, count: 0, search: "", lesson: lesson_id }}
      comp_props={{ create_comp: { lesson_id } }}
    />
  );
};

export default PayOptionList;
